module.exports = __webpack_public_path__ + "static/3-ac5df76065b7e4065a895f0ff4b1adf6.svg";